// extracted by mini-css-extract-plugin
export var redoItem = "_ng-1";
export var redoTrigger = "_ng-0";